import React from 'react';
import ReactDOM from 'react-dom/client';
import './Styles/Pages/index.css';
//import { Main } from './Pages/Main';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);